import ReactRouterLink from "@/components/ReactRouterLink/ReactRouterLink";
import { AgentObj } from "@/types/interfaces/agents";
import { Link, Tooltip } from "@mui/joy";
import { getStatusColor } from "./utils";
import { Star, StarBorderOutlined } from "@mui/icons-material";

type NoteCellRendererProps = {
  data: AgentObj;
};

const NoteCellRenderer = ({ data }: NoteCellRendererProps) => {
  return (
    // Quiet unless there's a note: the same icon on every row was noise
    <Tooltip title={data?.note || "Open notes"} arrow placement="right" size="sm">
      <Link
        component={ReactRouterLink}
        to={`/admin/agents/profile?email=${encodeURIComponent(data?.ttandEmail || "")}&tab=notes`}
        color={data?.note ? getStatusColor(data) : "neutral"}
        underline="none"
        aria-label="Open notes"
        sx={{
          "--Icon-fontSize": "18px",
          color: data?.note ? undefined : "neutral.400",
          "&:hover": { color: "primary.plainColor" },
        }}
      >
        {data?.note ? <Star /> : <StarBorderOutlined />}
      </Link>
    </Tooltip>
  );
};

export default NoteCellRenderer;
